import { apiCall, ApiConfig } from '../../config/api'
import { Warehouse } from '../../interfaces/Warehouse'
import { getWarehousesAction } from '../actions/warehouseActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_WAREHOUSES } from '../types/warehouseActionsTypes'
import { DataGridElements } from '../../interfaces/index'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se módifica saga para solo obtener los warehouse activos
*/

export function* getWarehousesAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<Warehouse>> =
      yield call(
        apiCall,
        'GET',
        `${ApiConfig.WareHouseApi}?pageSize=50&active=true`
      )
    if (status === 200) {
      yield put(getWarehousesAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getWarehousesAction([], serverError.message))
  }
}

export function* watchGetWarehousesAsync() {
  yield takeEvery(GET_WAREHOUSES, getWarehousesAsync)
}
